import { render, staticRenderFns } from "./JourneyPage.vue?vue&type=template&id=d2485f5e&scoped=true&"
import script from "./JourneyPage.vue?vue&type=script&lang=js&"
export * from "./JourneyPage.vue?vue&type=script&lang=js&"
import style0 from "./JourneyPage.vue?vue&type=style&index=0&id=d2485f5e&lang=scss&scoped=true&"
import style1 from "./JourneyPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2485f5e",
  null
  
)

export default component.exports